import * as consentManagementTypes from './consentManagementTypes';

const initialState = {
  filter: undefined,
  consentForIndex: undefined,
  consentForId: undefined,
  countryCodeIndex: undefined,
  countryCodeId: undefined,
  consentTypeIndex: undefined,
  consentTypeId: undefined,
  applicableToIndex: undefined,
  applicableToId: undefined,
  consentTaxYearIndex: undefined,
  consentTaxYearId: undefined,
  startDate: undefined,
  endDate: undefined,
  startDateInput: undefined,
  endDateInput: undefined,
};

const consentManagementFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case consentManagementTypes.CLEAR_FILTER:
      return { ...state, ...initialState };

    case consentManagementTypes.ON_CHANGE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export { initialState };
export default consentManagementFilterReducer;
